@if (!unavailable) {
  @if (loading && !rows.length) {
    <p class="uc-empty">Chargement…</p>
  } @else if (!rows.length) {
    <p class="uc-empty">Aucun appel en attente.</p>
  } @else {
    <ul class="uc-list">
      @for (r of rows; track r.uuid) {
        <li class="uc-row" [class.uc-row--client]="r.client">
          <div class="uc-row__main">
            <p class="uc-row__name">
              <span>{{ r.name }}</span>
              <span class="uc-chip" [class.uc-chip--client]="r.client">{{ r.client ? 'Client' : (r.target === 'mairie' ? 'Mairie' : 'Prospect') }}</span>
            </p>
            <p class="uc-row__detail">{{ r.first_name }} · {{ detail(r) }}</p>
            @if (r.message) { <p class="uc-row__message">« {{ r.message }} »</p> }
          </div>
          <div class="uc-row__side">
            <span class="uc-row__when" [class.uc-row__when--late]="late(r)">{{ when(r) }}</span>
            <a class="uc-row__phone" [href]="telHref(r.phone)">{{ r.phone }}</a>
          </div>
        </li>
      }
    </ul>
  }
  <a class="uc-more" [routerLink]="['/admin/prospection/rappels']" [queryParams]="clients ? { qui: 'clients' } : {}" (click)="navigate.emit()">
    {{ total > rows.length ? 'Voir les ' + total + ' rappels' : 'Ouvrir les rappels' }} →
  </a>
}
